import { Button, ModalRedirect, WrapperGeneral } from "components";

import {
	IcoAppStore,
	IcoAppStoreMobile,
	IcoExternalLink,
	IcoGlobalCompact,
	IcoGPTW,
	IcoGPTW10k24,
	IcoLinkedInCircle,
	IcoMOTV3,
	IcoODS,
	IcoPlayStore,
	IcoPlayStoreMobile,
	IcoYoutubeCircle
} from "assets/icons";
import { LogoWhite } from "assets/images";
import { useCallback, useEffect, useMemo, useState } from "react";

import { Constants } from "appConstants";
import EulaModal, { EulaSections } from "components/EulaModal";
import { ExternalAuthService } from "services/externalAuth";
import "./styles.scss";

export default function Footer() {
	const [redirectModalOpen, setRedirectModalOpen] = useState<boolean>(false);
	const [isEulaModalOpen, setIsEulaModalOpen] = useState<boolean>(false);
	const [selectedEulaSection, setSelectedEulaSection] = useState<EulaSections>(EulaSections.TERMS);
	const [isMobile, setIsMobile] = useState<boolean>(false);
	const extAuthService = new ExternalAuthService();
	const thisYear = useMemo(() => new Date().getFullYear(), []);

	const openEulaSection = useCallback((section: EulaSections) => {
		setIsEulaModalOpen(true);
		setSelectedEulaSection(section);
	}, []);

	const handleResize = () => {
		setIsMobile(window.innerWidth < 768);
	};

	useEffect(() => {
		handleResize();
		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	const handleRedirect = () => {
		setRedirectModalOpen(true);
		setTimeout(() => {
			setRedirectModalOpen(false);
			extAuthService.loginB2C();
		}, 1000);
	};

	return (
		<>
			<div className="container-footer">
				<div className="content-list-links">
					<WrapperGeneral className="md:flex md:items-start md:gap-6 md:px-8">
						<div className="md:w-[896px] flex flex-col md:flex-row gap-12 md:gap-6 flex-wrap">
							<div className="links md:pr-0">
								<h3 className="headline-3 md:max-w-[408px]">Motiva Portal de Isentos</h3>
								<Button size="small" onClick={handleRedirect} kind="link" hierarchy="ghost">
									Acessar plataforma <IcoExternalLink size="16" color="#fff" />
								</Button>
								<Button size="small" kind="link" hierarchy="ghost" onClick={handleRedirect}>
									Acompanhar minhas solicitações
									<IcoExternalLink size="16" color="#fff" />
								</Button>
							</div>
							<div className="links pb-0 max-md:pt-0">
								<h3 className="headline-3">Institucional</h3>
								<Button size="small" kind="link" hierarchy="ghost">
									<a href="https://rodovias.motiva.com.br/" target="_blank" rel="noreferrer">
										Motiva Rodovias
									</a>
									<IcoExternalLink size="16" color="#fff" />
								</Button>
								<Button size="small" kind="link" hierarchy="ghost">
									<a href="https://www.motiva.com.br/" target="_blank" rel="noreferrer">
										Motiva
									</a>
									<IcoExternalLink size="16" color="#fff" />
								</Button>
								<Button size="small" kind="link" hierarchy="ghost">
									<a href="https://motivapagamentos.com.br/" target="_blank" rel="noreferrer">
										Motiva Pagamentos
									</a>
									<IcoExternalLink size="16" color="#fff" />
								</Button>
							</div>
							<div className="links pb-10">
								<h3 className="headline-3">Fale Conosco</h3>
								<Button size="small" kind="link" hierarchy="ghost">
									<a
										href="https://www.motiva.com.br/contatos/?tabIndex=1#f21d217838ae9daf0af818fa2dcbd025"
										target="_blank"
										rel="noreferrer"
									>
										Contatos Motiva
									</a>
									<IcoExternalLink size="16" color="#fff" />
								</Button>
								<Button size="small" kind="link" hierarchy="ghost">
									<a href="https://www.motiva.com.br/contatos/#347ad7372a9dd13317e129a22da0edd1" target="_blank" rel="noreferrer">
										Ouvidoria
									</a>
									<IcoExternalLink size="16" color="#fff" />
								</Button>
								<Button size="small" kind="link" hierarchy="ghost">
									<a href="https://canalconfidencial.com.br/canalconfidencialmotiva/" target="_blank" rel="noreferrer">
										Canal Confidencial
									</a>
									<IcoExternalLink size="16" color="#fff" />
								</Button>
							</div>
						</div>
					</WrapperGeneral>
					{isMobile && (
						<div className="flex py-6 px-4 justify-center border-t border-[#666] ">
							<div className="flex gap-[45px]">
								<a
									href="https://www.linkedin.com/company/motivamobilidade/"
									target="_blank"
									rel="noreferrer"
									aria-label="LinkedIn Motiva"
								>
									<IcoLinkedInCircle />
								</a>
								<a href="https://www.youtube.com/@motivamobilidade" target="_blank" rel="noreferrer" aria-label="Youtube Motiva">
									<IcoYoutubeCircle />
								</a>
							</div>
						</div>
					)}
				</div>
				<div className="content-about">
					<WrapperGeneral className="md:px-8 pb-4 md:pb-6">
						<div className="flex flex-col gap-8 w-full">
							<div className="links-shared gap-14">
								<div className="flex flex-col md:flex-row gap-8 md:gap-6">
									<img src={LogoWhite} alt="Logo Motiva" className="max-w-[160px] h-fit self-start md:self-center" />
									<div className="address-link">
										<address className="not-italic text-[13px] md:text-[15px] md:max-w-[645px]">
											Edifício Eldorado Business Tower - Av. Dra. Ruth Cardoso, 8.501 - 5º andar, Pinheiros - São Paulo - SP -
											CEP: 05425-070 © {thisYear} Motiva
										</address>
										<ul>
											<li>
												<Button
													childrenWrapperClassName="text-[13px] md:text-[15px]"
													kind="link"
													hierarchy="ghost"
													onClick={() => openEulaSection(EulaSections.TERMS)}
												>
													Termos de uso
												</Button>
											</li>
											<li className="self-center">•</li>
											<li>
												<Button
													childrenWrapperClassName="text-[13px] md:text-[15px]"
													kind="link"
													hierarchy="ghost"
													onClick={() => openEulaSection(EulaSections.PRIVACY)}
												>
													Política de privacidade
												</Button>
											</li>
											<li className="self-center">•</li>
											<li>
												<Button
													childrenWrapperClassName="text-[13px] md:text-[15px]"
													kind="link"
													hierarchy="ghost"
													onClick={() => openEulaSection(EulaSections.COOKIES)}
												>
													Política de cookies
												</Button>
											</li>
										</ul>
									</div>
								</div>
								<div className="flex gap-2 md:gap-4 items-end max-w-[250px] md:max-w-fit">
									<a
										href="https://apps.apple.com/br/app/ccr-rodovias/id1638407440"
										target="_blank"
										rel="noreferrer"
										aria-label="AppStore"
									>
										{isMobile ? <IcoAppStoreMobile /> : <IcoAppStore />}
									</a>
									<a
										href="https://play.google.com/store/apps/details?id=br.com.grupoccr.approdovias&hl=pt_BR&gl=US"
										target="_blank"
										rel="noreferrer"
										aria-label="PlayStore"
									>
										{isMobile ? <IcoPlayStoreMobile /> : <IcoPlayStore />}
									</a>
								</div>
							</div>
							{!isMobile && (
								<div className="flex justify-between">
									<div className="flex gap-[45px] self-center">
										<a
											href="https://www.linkedin.com/company/motivamobilidade/"
											target="_blank"
											rel="noreferrer"
											aria-label="LinkedIn Motiva"
										>
											<IcoLinkedInCircle />
										</a>
										<a
											href="https://www.youtube.com/@motivamobilidade"
											target="_blank"
											rel="noreferrer"
											aria-label="Youtube Motiva"
										>
											<IcoYoutubeCircle />
										</a>
									</div>
									<div className="flex gap-[45px] justify-end mb-4 md:mb-0">
										<IcoGlobalCompact />
										<IcoMOTV3 />
										<IcoODS />
										<IcoGPTW />
										<IcoGPTW10k24 />
									</div>
								</div>
							)}
						</div>
					</WrapperGeneral>
					{isMobile && (
						<div className="border-t border-neutral-high-200 p-6 pb-10">
							<div className="flex gap-[20px] md:gap-[45px] justify-center md:justify-end md:mb-4 md:mb-0">
								<IcoGlobalCompact />
								<IcoMOTV3 />
								<IcoODS />
								<IcoGPTW />
								<IcoGPTW10k24 />
							</div>
						</div>
					)}
					<div className="border-t border-neutral-high-200">
						<div className="p-6 py-4 md:p-8 md:py-6 w-full col-span-4 text-[13px] md:text-[15px] md:max-w-[85rem] mx-auto">
							Este site é protegido pelo reCAPTCHA e pelos{" "}
							<a className="underline" href="https://policies.google.com/terms?hl=pt">
								Termos de uso
							</a>{" "}
							e{" "}
							<a className="underline" href="https://policies.google.com/privacy?hl=pt">
								Política de privacidade
							</a>{" "}
							do Google.
						</div>
					</div>
				</div>
				<ModalRedirect isOpen={redirectModalOpen} text={Constants.textRedirectLogin} />
			</div>
			<EulaModal displayedPolicy={selectedEulaSection} isOpen={isEulaModalOpen} onClose={() => setIsEulaModalOpen(false)} />
		</>
	);
}
